import { render, staticRenderFns } from "./ServiceListing.vue?vue&type=template&id=b6a64650&scoped=true&lang=pug&"
import script from "./ServiceListing.vue?vue&type=script&lang=ts&"
export * from "./ServiceListing.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceListing.vue?vue&type=style&index=0&id=b6a64650&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a64650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout,VSpacer})
